<template>
  <Dialog
    v-model:visible="modalStore.isOpen"
    :style="modalStore.style"
    :header="modalStore.title"
    modal
    :draggable="false"
    maximizable
    @hide="modalStore.close()"
  >
    <component
      :is="modalStore.component"
      v-bind="modalStore.props"
      @update:modelValue="handleChange"
      @close="modalStore.close"
    ></component>

    <template #footer>
      <Button
        v-for="(action, idx) in displayedButtons"
        :label="action.label"
        :icon="action.icon"
        :key="idx"
        text
        @click="handleCallback(action)"
        :size="action.size"
        :severity="action.severity"
        :loading="callbackLoadings[action?.label]"
        :disabled="isDisabled(action)"
      />
    </template>
  </Dialog>
</template>
<script>
  import { useModalStore } from '@/stores/modalStore';
  import useComponentConfig from '@/composables/useComponentConfig';

  import Button from 'primevue/button';
  import Dialog from 'primevue/dialog';

  // import Icon from './Icon.vue'

  export default {
    name: 'Modal',
    components: {
      Button
    },
    data() {
      return {
        modalStore: useModalStore(),
        data: null,
        callbackLoadings: {},
        componentConfig: useComponentConfig()
      };
    },

    computed: {
      displayedButtons() {
        return this.modalStore.actions.filter((a) => a.label);
      }
    },

    methods: {
      handleChange(val) {
        this.modalStore.modelValue = { ...this.modalStore.modelValue, ...val };
      },
      isDisabled(action) {
        try {
          if (typeof action.disabled === 'function') {
            return !!action.disabled(this.modalStore.modelValue);
          }
          return !!action.disabled;
        } catch (_) {
          return false;
        }
      },
      async handleCallback(action) {
        if (this.callbackLoadings[action.label]) {
          return;
        }

        this.callbackLoadings[action.label] = true;

        try {
          await action.callback();
        } catch (err) {
          throw err;
        } finally {
          this.callbackLoadings[action.label] = false;
        }
      }
    }
  };
</script>
